import { ComparePage } from "./ComparePage";
import { useLang } from "../lib/i18n";
import { compareOtterCopy } from "../lib/translations/pages/compare-otter";

export function CompareOtter() {
  const lang = useLang();
  return <ComparePage copy={compareOtterCopy[lang]} path="/compare/otter-vs-minuta" />;
}
